module.exports = __webpack_public_path__ + "img/500.e9dedc50.svg";